import { render, staticRenderFns } from "./PreviewImageModal.vue?vue&type=template&id=4c28944e"
import script from "./PreviewImageModal.vue?vue&type=script&lang=js"
export * from "./PreviewImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports